<template>
  <div class="collection-item" :style="textStyle">
    <div
      :class="`collection-item-content ${collectionItem.type=='triple-reverse' ? 'reverse' : ''}`"
      v-if="collectionItem.items && collectionItem.items.length > 0"
    >
      <div class="collection-card card-primary">
        <!-- <img :src="collectionItem.items[0].acf.video_thumbnail.url" /> -->
        <div class="collectionItemImg" :style="{'background-image': `url(${collectionItem.items[0].acf.video_thumbnail.url})`}"></div>
        <router-link
          :to="`${global.mainPage.presentationId ? `/presentation/${global.mainPage.presentationId}` : ''}/collection/${collectionItem.items[0].id}`"
        >
          <div class="collection-card-cover"></div>
          <div class="title-container">
            <span class="collection-card-title">{{collectionItem.items[0].acf.title}}</span>
          </div>
        </router-link>
      </div>

      <div v-if="collectionItem.items.length > 1" class="flex-col">
        <div
          v-for="(item, index) in collectionItem.items.slice(1)"
          :key="'collectionItem' + index"
          class="collection-card"
        >
          <!-- <img :src="item.acf.video_thumbnail.url" /> -->
          <div class="collectionItemImg" :style="{'background-image': `url(${item.acf.video_thumbnail.url})`}"></div>
          <router-link
            :to="`${global.mainPage.presentationId ? `/presentation/${global.mainPage.presentationId}` : ''}/collection/${item.id}`"
          >
            <div class="collection-card-cover"></div>
            <div class="title-container">
              <span class="collection-card-title">{{item.acf.title}}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CollectionItem",
  props: {
    collectionItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(["global"]),
    secondaryFontColor(){
      return `--green_font: ${this.$store.getters.themeSettings.secondary_font_color};`;
    },
    mainFontColor(){
      return `--main_font: ${this.$store.getters.themeSettings.main_font_color};`;
    },
    videoTitleSize(){
      return `--video_title_size: ${this.$store.getters.fontSettings.video_title.font_size}px;`;
    },
    videoFontStyle(){
      return `--video_title_font_style: "${this.$store.getters.fontSettings.video_title.font_style}";`;
    },
    textStyle() {
      return `${this.secondaryFontColor} ${this.mainFontColor} ${this.videoTitleSize} ${this.videoFontStyle}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.collection-item {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  background: #000;
  width: 100vw;
  height: 37.44vw;
  max-height: 37.44vw;
  @media (max-width: $lg) {
    height: 84.375vw;
    max-height: 84.375vw;
  }
  @media (max-width: $md) {
    height: 168.75vw;
    max-height: 168.75vw;
  }
  .collection-item-content {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    max-height: 100%;

    @media (max-width: $lg) {
      flex-direction: column !important;
    }

    > div {
      flex: 2;
    }

    .flex-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      height: 100%;

      @media (max-width: $lg) {
        flex-direction: row;
      }

      @media (max-width: $md) {
        flex-direction: column;
        flex: 4;
      }
      > div {
        flex: 1;
      }
    }

    .collection-card {
      position: relative;
      transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
      overflow: hidden;
      z-index: 1;
      cursor: pointer;

      img {
        transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
      }

      .collection-card-cover {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000;
        opacity: 0.5;
        transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .title-container {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        span {
          font-family: "AvenirLTStd-Roman";
          font-family: var(--video_title_font_style);
          font-size: 18px;
          font-size: var(--video_title_size);
          color: var(--main_font);
          letter-spacing: 0;
          line-height: 24px;
          text-transform: uppercase;
          width: 100%;
          padding: 20px;
          text-align: center;
        }
      }
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .collectionItemImg{
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  }
}
.reverse {
  flex-direction: row-reverse !important;
}

.can-hover {
  span {
    opacity: 0;
  }
  .collection-card {
    @media (min-width: $md) {
      span {
        transform: none !important;
      }
      &:hover {
        height: 100%;
        width: 100%;
        img {
          transform: scale(1.05);
          max-width: 105vw;
          max-height: 105vh;
        }
        .collectionItemImg{
          transform: scale(1.05);
        }
        span {
          opacity: 1 !important;
        }
        .collection-card-cover {
          opacity: 0;
        }
      }
    }
    @media (max-width: $md) {
      height: 100%;
      width: 100%;
      span {
        opacity: 0;
      }
      .collection-card-cover {
        opacity: 0;
      }
    }
  }
}
.no-hover {
  .collection-card {
    height: 100%;
    width: 100%;
    // span {
    //   opacity: 1 !important;
    // }
    // .collection-card-cover {
    //   opacity: 0 !important;
    // }
  }
}
.collection-card{
  .collection-card-title{
    opacity: 0;
  }
  &:hover{
    .collection-card-title{
      opacity: 1;
    }
  }
}
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>